import styles from "./SkillItem.module.css";

export const SkillItem = ({ name, progress }) => {
  return (
    <div className={styles.data}>
      <div className={styles.title}>
        <h3 className={styles.name}>{name}</h3>
        {progress && <span className={styles.progress}>{progress}%</span>}
      </div>
      {progress && (
        <div className={styles.bar}>
          <span
            className={styles.percentage}
            style={{ width: progress + "%" }}
          ></span>
        </div>
      )}
    </div>
  );
};
